import axios from "axios";
import {v4 as uuidv4} from "uuid";
import {addFailedFile} from "./uploadState";
import COS from "cos-js-sdk-v5";
import i18n from "i18next";

export const getId = () => {
  if (!localStorage.getItem('fdd_uid')) {
    const id = uuidv4();
    console.info('uuid is', id, typeof id);
    localStorage.setItem('fdd_uid', id.replace(/-/g, ''));
  }
  return localStorage.getItem('fdd_uid');
}

/**
 * 格式化文件大小
 * @param bytes 字节数
 * @returns 格式化后的文件大小字符串
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/**
 * 获取随机路径是否开启
 */
export const getRandomPathEnabled = () => {
  const stored = localStorage.getItem('imgcloud_random_path_enabled');
  return stored === null ? true : stored === 'true';
}
/**
 * 上传文件
 * @param file
 * @param onUploadProgress
 * @param errorCallback
 */
export const postFile = async (
  file: any,
  onUploadProgress: (p: number) => void,
  errorCallback: (errorMessage: string, fileName: string) => void,
  dir?: string
) => {
  let rawLink = '';
  if ((window as any)._debug_) {
    rawLink = await postFileToCos(file, onUploadProgress, errorCallback, dir) || '';
  }

  const formData = new FormData();
  if (rawLink) {
    formData.append('fromUrl', rawLink);
  } else {
    formData.append('file', file);
  }
  formData.append('fileName', file.webkitRelativePath || file.name);
  formData.append('uid', getId() as any);
  formData.append('randomPath', getRandomPathEnabled() as any);
  if (dir) {
    formData.append('dir', dir);
  }
  return axios.request({
    method: 'post',
    url: '/img/upload',
    data: formData,
    onUploadProgress: (p) => {
      const percent = Math.floor(p.loaded / (p.total || 0) * 100);
      console.info('percent is', percent);
      onUploadProgress && onUploadProgress(percent);
    }
  }).then(res => {
    console.log("upload.then");
    const record = res.data;
    const url = record.url;
    console.info('url is ', url);
    if ((res as any).success == false) {
      if (errorCallback != null) {
        errorCallback((res as any).message, file.name);
        addFailedFile(file.name, (res as any).message, file);
      } else {
        alert((res as any).message);
      }
    }
  }).catch(error => {
    console.warn("upload.catch", error);
    if (error.response && error.response.status === 413) {
      const msg = i18n.t('error.fileTooLarge');
      if (errorCallback != null) {
        errorCallback(msg, file.name);
        addFailedFile(file.name, msg, file);
      } else {
        alert(msg);
      }
    } else {
      const res = error.response.data;
      if (errorCallback != null) {
        errorCallback((res as any).message, file.name);
        addFailedFile(file.name, (res as any).message, file);
      } else {
        alert((res as any).message);
      }
    }
  })
}

/**
 * 上传文件并返回URL
 * @param file 文件
 * @param dir 目录
 * @returns 上传后的URL
 */
export const uploadFileAndGetUrl = async (
  file: File,
  dir?: string
): Promise<string> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', file.webkitRelativePath || file.name);
  formData.append('uid', getId() as string);
  formData.append('randomPath', getRandomPathEnabled() as any);
  if (dir) {
    formData.append('dir', dir);
  }

  try {
    const response = await axios.request({
      method: 'post',
      url: '/img/upload',
      data: formData,
    });

    const record = response.data;

    if (record.url) {
      return record.url;
    }
    throw new Error(record.message || i18n.t('error.uploadFailed'));
  } catch (error: any) {
    // 如果是 axios 错误，尝试从响应中提取服务端错误信息
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    // 如果是文件过大的错误
    if (error.response?.status === 413) {
      throw new Error(i18n.t('error.fileTooLarge'));
    }
    // 如果已经是 Error 实例（包括上面抛出的业务错误），直接重新抛出
    if (error instanceof Error) {
      throw error;
    }
    throw new Error(i18n.t('error.uploadFailed'));
  }
};

export const postFileToCos = async (
  file: any,
  onUploadProgress: (p: number) => void,
  errorCallback: (errorMessage: string, fileName: string) => void,
  dir?: string
) => {
  if (!(window as any)._info?.contextPath) {
    alert(i18n.t('error.contactOnError'))
    return;
  }

  let key = `autoupload/${(window as any)._info?.contextPath}/${(window as any)._dir || "default"}/` + (file.webkitRelativePath || file.name);
  
  // 将空格替换成下划线
  key = key.replace(/ /g, '_');

  await new Promise((resolve) => {
    fetch('/img/get_temp_ak_sk').then(res => res.json()).then(data => {
      const cos = new COS({
        SecretId: data.SecretId,
        SecretKey: data.SecretKey
      });

      cos.uploadFile({
        Bucket: "7295f60f8080-1257812490",
        Region: "ap-beijing",
        Key: key,
        Body: file, // 要上传的文件对象。
        onProgress: function(progressData) {
          console.log('上传进度：', progressData);
          onUploadProgress(progressData.percent * 100);
        }
      }, function (err, data) {
        console.log('上传结束', err || data);
        if (err) {
          errorCallback(err.message, file.name);
        }
        resolve({});
      });
    })
  })

  // 对key进行URL编码，处理特殊字符（空格已替换为下划线）
  // 注意：只编码路径部分，保留斜杠不编码
  const encodedKey = key.split('/').map(segment => encodeURIComponent(segment)).join('/');
  return `https://7295f60f8080-1257812490.cos.ap-beijing.tencentcos.cn/${encodedKey}`;
}
